import React from 'react';

import { Tile } from 'scenes/Gallery/components/Tiles';

const ThumbnailTile = ({ data, isSelected, onSelect }) => {
  const { id, name, thumbnailUrl } = data;
  return (
    <Tile
      withLabel={true}
      selected={isSelected(data)}
      onSelect={() => onSelect(data)}
      previewSrc={thumbnailUrl}
      id={id}
      name={name}
    />
  );
};

export default ThumbnailTile;
